<ion-header class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-buttons slot="end">
      <ion-button (click)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<!-- Content -->
<ion-content [scrollY]="true">
  <div
    *ngIf="{ growAccount: growAccount$ | async, hasInvestDetailsFlag: hasInvestDetailsFlag$ | async } as vm"
    class="inyova-grow-deposit-modal"
    [class.has-qr-code]="vm.hasInvestDetailsFlag"
  >
    <h2 class="ds-title-3">{{ 'GROW.deposit.modal.title' | translate }}</h2>
    @if (vm.hasInvestDetailsFlag) {
      <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'sp.accountDetails2.invest.subtitle' | translate }}</p>
    } @else {
      <p class="ds-heading-2">{{ 'GROW.deposit.modal.description' | translate }}</p>
    }

    <div class="invest-details-code">
      @if (vm.hasInvestDetailsFlag) {
        <p class="ds-heading-2">{{ 'sp.accountDetails2.qr.title' | translate }}</p>

        <div class="invest-code">
          <div class="invest-qr" [innerHTML]="vm.growAccount.deposit_qr_code | safeHtml"></div>

          <div class="invest-qr-details">
            <div class="invest-qr-dropdown">
              <div class="invest-qr-btn" (click)="toggleDetails()">
                <p class="ds-caption-1">{{ 'sp.accountDetails2.qr.usage.title' | translate }}</p>
                <app-ds-icon size="icon-size-2" [name]="showDetails ? 'chevron-up' : 'chevron-down'"></app-ds-icon>
              </div>

              @if (showDetails) {
                <div class="invest-qr-info">
                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="focus"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.' + (isAndroid ? 'android' : 'ios') | translate }}</p>
                  </div>

                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="smartphone"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.desc2' | translate }}</p>
                  </div>

                  <div>
                    <app-ds-rounded-icon size="small" variant="info" icon="qr-code"></app-ds-rounded-icon>
                    <p class="ds-ui-3">{{ 'sp.accountDetails2.qr.usage.desc3' | translate }}</p>
                  </div>
                </div>
                <p class="ds-ui-3 ds-color-core-neutral-8">{{ 'sp.accountDetails2.qr.usage.notice' | translate }}</p>
              }
            </div>
          </div>
        </div>

        <p class="ds-heading-2">{{ 'sp.accountDetails2.manual.title' | translate }}</p>
      }

      <div class="ds-rows-white">
        <div class="ds-row-white extra-padding">
          <div class="content">
            <div>
              <p class="ds-ui-2">{{ 'GROW.deposit.modal.initialTitle' | translate }}</p>
              <p class="ds-heading-2">{{ vm.growAccount.initial_investment | thousand: vm.growAccount.currency }}</p>
            </div>
            <div>
              @if (vm.hasInvestDetailsFlag) {
                <app-ds-icon name="copy" size="icon-size-3" (click)="copyToClipboard(vm.growAccount.initial_investment)"></app-ds-icon>
              } @else {
                <ion-icon name="copy" (click)="copyToClipboard(vm.growAccount.initial_investment)"></ion-icon>
              }
            </div>
          </div>
        </div>

        <div class="ds-row-white extra-padding">
          <div class="content">
            <div>
              <p class="ds-ui-2">{{ 'GROW.deposit.modal.ibanTitle' | translate }}</p>
              <p class="ds-heading-2">
                <ng-container *ngIf="vm.growAccount.iban; else showIbanLoader">{{ vm.growAccount.iban | iban }}</ng-container>
                <ng-template #showIbanLoader>
                  <ion-skeleton-text animated style="width: 150px; height: 12px"></ion-skeleton-text>
                </ng-template>
              </p>
            </div>
            <div>
              @if (vm.hasInvestDetailsFlag) {
                <app-ds-icon name="copy" size="icon-size-3" (click)="copyToClipboard(vm.growAccount.iban)"></app-ds-icon>
              } @else {
                <ion-icon name="copy" (click)="copyToClipboard(vm.growAccount.iban)"></ion-icon>
              }
            </div>
          </div>
        </div>

        <div class="ds-row-white extra-padding">
          <div class="content">
            <div>
              <p class="ds-ui-2">{{ 'GROW.deposit.modal.swiftTitle' | translate }}</p>
              <p class="ds-heading-2">{{ 'GROW.deposit.modal.swiftValue' | translate }}</p>
            </div>
            <div>
              @if (vm.hasInvestDetailsFlag) {
                <app-ds-icon name="copy" size="icon-size-3" (click)="copyToClipboard('swift')"></app-ds-icon>
              } @else {
                <ion-icon name="copy" (click)="copyToClipboard('swift')"></ion-icon>
              }
            </div>
          </div>
        </div>

        <div class="ds-row-white extra-padding">
          <div class="content">
            <div>
              <p class="ds-ui-2">{{ 'GROW.deposit.modal.addressTitle' | translate }}</p>
              <p class="ds-heading-2">{{ 'GROW.deposit.modal.addressValue' | translate }}</p>
            </div>
            <div>
              @if (vm.hasInvestDetailsFlag) {
                <app-ds-icon name="copy" size="icon-size-3" (click)="copyToClipboard('address')"></app-ds-icon>
              } @else {
                <ion-icon name="copy" (click)="copyToClipboard('address')"></ion-icon>
              }
            </div>
          </div>
        </div>

        <div class="ds-row-white extra-padding">
          <div class="content">
            <div>
              <p class="ds-ui-2">{{ 'GROW.deposit.modal.beneficiaryTitle' | translate }}</p>
              <p class="ds-heading-2">{{ vm.growAccount.owner_name }}</p>
            </div>
            <div>
              @if (vm.hasInvestDetailsFlag) {
                <app-ds-icon name="copy" size="icon-size-3" (click)="copyToClipboard(vm.growAccount.customer_name)"></app-ds-icon>
              } @else {
                <ion-icon name="copy" (click)="copyToClipboard(vm.growAccount.customer_name)"></ion-icon>
              }
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="deposit-list">
      <h3 class="ds-heading-2">{{ 'GROW.deposit.list.title' | translate }}</h3>
      <ul class="ds-list">
        <li>
          <app-ds-rounded-icon icon="send-to-back" variant="custom" customColor="var(--color-core-brand-6-2)"></app-ds-rounded-icon>
          <div>
            <p class="ds-heading-3">{{ 'GROW.deposit.list.step1.title' | translate }}</p>
            <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.deposit.list.step1.desc' | translate }}</p>
          </div>
        </li>
        <li>
          <app-ds-rounded-icon icon="square-arrow-down" variant="custom" customColor="var(--color-core-brand-4-3)"></app-ds-rounded-icon>
          <div>
            <p class="ds-heading-3">{{ 'GROW.deposit.list.step2.title' | translate }}</p>
            <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.deposit.list.step2.desc' | translate }}</p>
          </div>
        </li>
        <li>
          <app-ds-rounded-icon icon="earth" variant="custom" customColor="var(--color-core-brand-3-5)"></app-ds-rounded-icon>
          <div>
            <p class="ds-heading-3">{{ 'GROW.deposit.list.step3.title' | translate }}</p>
            <p class="ds-ui-2 ds-color-core-neutral-8">{{ 'GROW.deposit.list.step3.desc' | translate }}</p>
          </div>
        </li>
      </ul>
    </div>
    <app-ds-button variant="primary" (clicked)="onCloseModal()">{{ 'GROW.deposit.modal.closeButton' | translate }}</app-ds-button>
  </div>
</ion-content>
